import React, { useState } from 'react';
import { Col, Row } from 'antd';
import { Button, Input } from '../../components';
import { Strings } from '../../utils/strings';
import { API_RESET_PASSWORD, API_SUBMIT_OTP } from '../../config/API';
import { toast } from 'react-toastify';
import { axios } from '../../config';
import qs from 'qs';
import { useNavigate } from 'react-router-dom';
const ResetPassword = () => {
  const [email, setEmail] = useState('');
  const [otp, setOtp] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [formVisibility, setFormVisibility] = useState(true);
  const navigate = useNavigate();
  const sendResetRequest = () => {
    try {
      const onSuccess = ({ response }) => {
        // console.log(response);
        toast.success(response.data.message);
        setFormVisibility(false);
      };

      const onFailure = (error) => {
        // console.log(error);
        toast.warn(error.response.data?.message ?? 'Request Failed');
      };
      const data = qs.stringify({
        email: email,
      });

      const config = {
        maxBodyLength: Infinity,
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
          Accept: 'application/json',
        },
      };

      axios
        .post(API_RESET_PASSWORD, data, config)
        .then((response) => {
          onSuccess({ response });
        })
        .catch((error) => {
          onFailure(error);
        });
    } catch (e) {
      toast.warn(e.toString() ?? 'Something went wrong');
    }
  };

  function maskEmail({ userEmail }) {
    try {
      const email = userEmail;
      const atIndex = email.indexOf('@');
      const masked = `${email.substring(0, 2)}${'*'.repeat(
        atIndex - 2
      )}${email.substring(atIndex)}`;
      return masked;
    } catch (e) {
      console.log(e);
      return userEmail;
    } // Output: sa********3@gmail.com
  }

  const submitOTP = () => {
    if (password !== confirmPassword) {
      return toast.warn('Passwords do not match');
    }
    try {
      const onSuccess = ({ response }) => {
        toast.success(response.data.message);
        setEmail('');
        setOtp('');
        setPassword('');
        setConfirmPassword('');
        setTimeout(() => {
          navigate('/login');
        }, 1800);
      };

      const onFailure = (error) => {
        // console.log(error);
        toast.warn(error.response.data?.message ?? 'Request Failed');
      };
      const data = qs.stringify({
        email: email,
        otp: otp,
        password: password,
      });
      const config = {
        maxBodyLength: Infinity,
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
          Accept: 'application/json',
        },
      };

      axios
        .post(API_SUBMIT_OTP, data, config)
        .then((response) => {
          onSuccess({ response });
        })
        .catch((error) => {
          onFailure(error);
        });
    } catch (e) {
      toast.warn(e.toString() ?? 'Something went wrong');
    }
  };

  return (
    <Row style={{ height: window.innerHeight }} className="loginContainer">
      <Col md={12}>
        <div>
          <div className="left">
            <img
              src={require('../../images/logo.png')}
              style={{ width: '200px' }}
              alt="woosla"
              className="logo"
            />
            {/* <div> */}
            <h2 style={{ marginBottom: '10px' }}>Reset Password</h2>
            {formVisibility ? (
              <>
                <p align="left">
                  Please enter the email address associated with your account .{' '}
                  <br />
                  <br />
                  We'll send an OTP to this email to help you reset your
                  password.
                </p>
                <Input
                  placeholder={'Enter your email'}
                  onChange={setEmail}
                  value={email}
                />
                <Button
                  title="Reset"
                  block
                  onClick={sendResetRequest}
                  disabled={!email}
                />
              </>
            ) : (
              <>
                <p align="left">
                  Please enter the OTP received on the email{' '}
                  {maskEmail({
                    userEmail: email,
                  })}{' '}
                  {'\n'}
                </p>
                <Input
                  placeholder={'Enter your OTP'}
                  onChange={setOtp}
                  value={otp}
                />
                <Input
                  placeholder={'Enter new password'}
                  onChange={setPassword}
                  value={password}
                  type="password"
                />
                <Input
                  placeholder={'Confirm new password'}
                  onChange={setConfirmPassword}
                  value={confirmPassword}
                  type="password"
                />
                <Button
                  title="Reset"
                  block
                  onClick={submitOTP}
                  disabled={!email || !password || !confirmPassword || !otp}
                />
              </>
            )}
          </div>
        </div>
      </Col>
      <Col md={12}>
        <div
          className="right"
          style={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            alignContent: 'center',
          }}
        >
          <Row align={'middle'}>
            <img
              //  src={require("../../images/login.svg").default}
              src={require('../../images/login.png')}
              alt=""
              style={{ width: '100%' }}
            />
          </Row>
          <Row className="loginPromoRow">
            <span className="loginPromoText">{Strings.Login.promoText}</span>
            {Strings.Login.subText}
          </Row>
        </div>
      </Col>
    </Row>
  );
};

export default ResetPassword;
